import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementBlock as _createElementBlock } from "vue"

import { onMounted, computed, ref } from 'vue';
import SectionPanel from '../SectionPanel/SectionPanel.vue';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '../FormStepInputs/FormStepInputs.vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import RangeInput from '../RangeInput/RangeInput.vue';
import { IAgreedValueRange } from '@/interfaces/insurance-quote/agreed-value-range.interface';
import ModalDialog from '../ModalDialog/ModalDialog.vue';
import { QuoteVehicleValuationMethods } from '@/enums/quote-vehicle-valudation-methods.enum';

/** Local state and data properties*/
interface Props extends ISitecoreFormGenericInput {
  description: { value: string };
  valuationMethod: QuoteVehicleValuationMethods;
  agreedValueRange: IAgreedValueRange;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'InsuredAmountValuationMethod',
  props: {
    description: {},
    valuationMethod: {},
    agreedValueRange: {},
    id: {},
    name: {},
    label: {},
    formInputId: {},
    inputType: {},
    placeholderText: {},
    postContent: {},
    preContent: {},
    postContentClass: {},
    preContentClass: {},
    tooltipContent: {},
    tooltipModalTitle: {},
    tooltipShowInModal: {},
    fields: {},
    emptyMessage: {},
    validation: {},
    outerClass: {},
    innerClass: {},
    refData: {},
    prefixIcon: {},
    suffixIcon: {},
    helpXs: {},
    helpSm: {},
    helpMd: {},
    disablePaste: {},
    classesOptions: {},
    showClearIcon: {},
    autocomplete: {},
    options: {},
    optionsClass: {},
    defaultOption: {},
    inputInnerClass: {},
    isRequired: {},
    isRequiredErrorMessage: {},
    validationRegex: {},
    validationRegexErrorMessage: {},
    mustAccept: {},
    mustAcceptErrorMessage: {},
    mask: {},
    isHidden: { type: Boolean },
    showPostContent: { type: Boolean },
    dynamicOptions: {},
    elementId: {},
    titleRequiredMessage: {},
    firstnameRequiredErrorMessage: {},
    firstnameRegex: {},
    firstnameRegexErrorMessage: {},
    lastnameRequiredErrorMessage: {},
    lastnameRegex: {},
    lastnameRegexErrorMessage: {},
    format: {},
    pickerOnly: {},
    minDateToday: {},
    maxDateByDays: {},
    icon: {},
    title: {},
    subTitle: {},
    decimals: {},
    minDecimals: {},
    noDecimalsErrorMessage: {},
    min: {},
    max: {},
    minlength: {},
    maxlength: {},
    promoCards: {},
    heading: {},
    cardLayout: {},
    maxItemsToShow: {}
  },
  setup(__props: any) {

const props = __props;

/** Computed Properties */
const showTooltip = ref(false);
const formInputs = computed(() => {
  const inputs: Record<string, ISitecoreFormGenericInput> = {};
  props.fields?.forEach((item) => {
    inputs[item.name] = item;
  });
  return inputs;
});

const showAgreedValue = computed(() => {
  return props.valuationMethod == QuoteVehicleValuationMethods.AGREED_VALUE;
});

const tooltipContent = computed(() => {
  const item = props.fields?.find((item) => item.name == 'tooltipContent') as Record<string, any>;
  return {
    title: item?.title,
    content: item?.content,
  };
});
/** Functions */

/** Lifecycle Hooks */
onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(SectionPanel, _normalizeProps(_guardReactiveProps(_ctx.$props)), {
      sectionPanelContent: _withCtx(() => [
        _createVNode(FormStepInputs, {
          step: {
            formInputs: formInputs.value,
          }
        }, {
          marketValueHelpText: _withCtx(() => [
            _createElementVNode("div", null, [
              (!showAgreedValue.value)
                ? (_openBlock(), _createBlock(_unref(RichText), {
                    key: 0,
                    field: formInputs.value.marketValueHelpText.label,
                    class: _normalizeClass(formInputs.value.marketValueHelpText?.outerClass?.value)
                  }, null, 8, ["field", "class"]))
                : _createCommentVNode("", true)
            ])
          ]),
          agreedValueHelpText: _withCtx(() => [
            _createElementVNode("div", null, [
              (showAgreedValue.value)
                ? (_openBlock(), _createBlock(_unref(RichText), {
                    key: 0,
                    field: formInputs.value.agreedValueHelpText.label,
                    class: _normalizeClass(formInputs.value.agreedValueHelpText?.outerClass?.value)
                  }, null, 8, ["field", "class"]))
                : _createCommentVNode("", true)
            ])
          ]),
          vehicleAgreedValue: _withCtx(() => [
            _createElementVNode("div", null, [
              (showAgreedValue.value)
                ? (_openBlock(), _createBlock(RangeInput, _mergeProps({ key: 0 }, formInputs.value.vehicleAgreedValue, {
                    min: { value: _ctx.agreedValueRange.min },
                    max: { value: _ctx.agreedValueRange.max },
                    minLabel: { value: _ctx.agreedValueRange.minLabel },
                    maxLabel: { value: _ctx.agreedValueRange.maxLabel }
                  }), null, 16, ["min", "max", "minLabel", "maxLabel"]))
                : _createCommentVNode("", true)
            ])
          ]),
          learnMore: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_unref(RichText), {
                field: formInputs.value.learnMore.label,
                tag: "button",
                type: "button",
                class: "link text-m font-sans",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (showTooltip.value = true))
              }, null, 8, ["field"])
            ])
          ]),
          tooltipContent: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(ModalDialog, {
                modelValue: showTooltip.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showTooltip).value = $event)),
                closeOnEsc: true,
                showXCloseButton: true,
                size: "tooltip"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(RichText), {
                    field: tooltipContent.value.title,
                    class: "sticky-modal-header"
                  }, null, 8, ["field"]),
                  _createVNode(_unref(RichText), {
                    field: tooltipContent.value.content,
                    class: "tooltip-body richtext"
                  }, null, 8, ["field"])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["step"])
      ]),
      _: 1
    }, 16)
  ]))
}
}

})